export default "__VITE_ASSET__mFw6DDJb__"